import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffectOnce } from '@view/hooks/useEffectOnce';
import { usePageNavigation } from '@view/hooks/usePageNavigation';
export const PageNotFoundRedirect = () => {
    const { redirectNotFound } = usePageNavigation();
    useEffectOnce(() => {
        redirectNotFound('PAGE_NOT_FOUND');
    });
    return _jsx(_Fragment, {});
};
